// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2al0J","notes":"Notes_notes__3qSd2","note":"Notes_note__2cvY_","markdown":"Notes_markdown__1xVfr"};